import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";
import AdminMetricCard from "@/components/adminone/AdminMetricCard";
import AdminStatusPanel from "@/components/adminone/AdminStatusPanel";

export default function AdminOneDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  const load = async () => {
    setErr("");
    try {
      const { data } = await adminApi.dashboard();
      setData(data);
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || "Failed to load dashboard");
    }
  };
  useEffect(() => { load(); }, []);

  const m = data?.metrics || {};
  return (
    <div className="admin-page" data-testid="admin-dashboard">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Command Dashboard</h2>
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} data-testid="admin-dashboard-refresh">↻ Refresh</button>
      </div>
      {err && <div className="oracle-error">{err}</div>}

      <div className="admin-dashboard-grid">
        <div className="admin-metric-grid">
          <AdminMetricCard label="Total ORACLE Sessions" value={m.total_sessions ?? 0} testId="metric-sessions" />
          <AdminMetricCard label="Active Users" value={m.active_users ?? 0} testId="metric-users" />
          <AdminMetricCard label="Reports Generated" value={m.reports_generated ?? 0} testId="metric-reports" />
          <AdminMetricCard label="PDF Exports" value={m.pdf_exports ?? 0} testId="metric-exports" />
          <AdminMetricCard label="Compliance Flags" value={m.compliance_flags ?? 0} tone={(m.compliance_flags || 0) > 0 ? "warn" : "default"} testId="metric-compliance" />
          <AdminMetricCard label="HITL Reviews" value={m.hitl_reviews ?? 0} tone={(m.hitl_reviews || 0) > 0 ? "warn" : "default"} testId="metric-hitl" />
          <AdminMetricCard label="Watchlist Items" value={m.watchlist_items ?? 0} testId="metric-watchlist" />
          <AdminMetricCard label="Failed Logins" value={m.failed_api_calls ?? 0} tone={(m.failed_api_calls || 0) > 0 ? "danger" : "default"} testId="metric-failures" />
          <AdminMetricCard label="System Uptime" value={m.system_uptime || "online"} tone="success" testId="metric-uptime" />
          <AdminMetricCard label="OANDA Feed" value={data?.status?.oanda === "configured" ? "LIVE" : "KEYS REQ."} tone={data?.status?.oanda === "configured" ? "success" : "warn"} testId="metric-oanda" />
        </div>
        <AdminStatusPanel status={data?.status} />
      </div>

      <section className="admin-section">
        <h3 className="admin-section__title">Recent ORACLE Activity</h3>
        <ul className="admin-activity">
          {(data?.recent_activity || []).map((a, i) => (
            <li key={i} className="admin-activity__item">
              <span className="rc-pill">{(a.mode || "").toUpperCase()}</span>
              <span className="admin-activity__time">{a.created_at && new Date(a.created_at).toLocaleString()}</span>
              <div className="admin-activity__sum">{a.summary || "—"}</div>
            </li>
          ))}
          {(!data?.recent_activity || data.recent_activity.length === 0) && (
            <li className="oracle-empty" style={{ padding: 14 }}>No recent activity</li>
          )}
        </ul>
      </section>
    </div>
  );
}
